import { themeGet } from "@styled-system/theme-get"
import styled from "styled-components"

export const Highlight = styled.strong`
  color: ${themeGet("colors.blue100")};
`
